import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './PageSection.scss';
import { formatNumber } from '../../utils/formatNumber';

export type PageSectionProps = {
  title?: string;
  count?: number;
  children: ReactNode;
  titleClass?: string;
  className?: string;
  hasBorder?: boolean;
  fullWidth?: boolean;
  sectionRef?: React.RefObject<HTMLElement>;
};

export class PageSection extends React.PureComponent<PageSectionProps> {
  static defaultProps = {
    titleClass: 'jg-h2',
    className: '',
  };

  render() {
    const {
      children,
      title,
      count,
      titleClass,
      className,
      hasBorder,
      fullWidth,
      sectionRef,
    } = this.props;

    return (
      <section
        className={classNames(
          styles.pagesSection,
          className,
          { 'jg-bdt jg-bd--very-light-grey': hasBorder },
          { [styles.pagesSectionRestrictWidth]: !fullWidth },
        )}
        ref={sectionRef}
      >
        {title && (
          <header>
            <h1 className={titleClass} tabIndex={-1}>
              {title}
              {typeof count === 'number' && count > 0 && (
                <span data-qa="section-count" className="jg-pull-right">
                  {formatNumber(count)}
                </span>
              )}
            </h1>
          </header>
        )}
        {children}
      </section>
    );
  }
}

export default PageSection;
